import { Injectable, Inject } from '@angular/core'; 
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';
import { LCID_TO_LANG } from './lcid-mapping';
import { TgSettingsService } from '../TG-Setting_Services/tg-settings.service';
import {
  TRANSLATION_CONFIG,
  TranslationConfig
} from './translation-config.token';

const DEFAULT_LANG = 'en-US';

@Injectable({ providedIn: 'root' })
export class TranslationInitService {

  private initialized = false;
  private initPromise: Promise<void> | null = null;
  
  constructor(
    private translate: TranslateService,
    private tgSettingsService: TgSettingsService,
    @Inject(TRANSLATION_CONFIG) private config: TranslationConfig
  ) {
    this.initPromise = this.init();
  }

  private async init(): Promise<void> {
    if (this.initialized) return;
    this.initialized = true;

    try {
      await firstValueFrom(this.tgSettingsService.getSettings());

      const localeId = this.tgSettingsService.getLocaleId();
      const lang = LCID_TO_LANG[localeId] ?? DEFAULT_LANG;

      await firstValueFrom(this.translate.use(lang));
    } catch (err) {
      console.error('[TranslationInitService] Fallback to en-US', err);
      await firstValueFrom(this.translate.use(DEFAULT_LANG));
    }
  }

  async getTranslation(key: string, params?: any): Promise<string> {
    return this.translate.instant(key, params);
  }

  async getTranslationAsync(key: string): Promise<string> {
    await this.initPromise;
    return firstValueFrom(this.translate.get(key));    
  }
  
  getInstantTranslation(key: string, params?: any): string {
    return this.translate.instant(key, params);
  }
}
